import {
  API_BASE_URL,
  baseUrlConfig,
} from "../../configurations/configurations";

export const handleDownloadClick = async (
  isTicketFileDownload = false,
  userId,
  fileId,
  messageId,
  isMessageAttachment
) => {
  const { API_ROOT_URL } = baseUrlConfig.development;

  let baseUrl = `${API_ROOT_URL}${API_BASE_URL}`;
  let endpoint = isTicketFileDownload ? "ticket_files" : "files";

  let url = new URL(`${baseUrl}/${endpoint}/download/${userId}/${fileId}`);

  if (isTicketFileDownload) {
    if (messageId) {
      url.searchParams.append("messageId", messageId);
    }
    if (isMessageAttachment) {
      url.searchParams.append("isMessageAttachment", isMessageAttachment);
    }
  }

  try {
    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const contentDispositionHeader = response.headers.get(
      "Content-Disposition"
    );
    let fileName = "download";
    if (contentDispositionHeader) {
      const filenameMatch =
        contentDispositionHeader.match(/filename="?(.+)"?/i);
      if (filenameMatch && filenameMatch[1]) {
        fileName = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ""));
      }
    }

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    // Clean up
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);
  } catch (error) {
    console.error("Download failed:", error);
  }
};
